import { Component, OnInit, Input } from '@angular/core';
import { ProductsService } from '../services/products.service';

@Component({
  selector: 'app-products-bar',
  templateUrl: './products-bar.component.html',
  styleUrls: ['./products-bar.component.scss']
})
export class ProductsBarComponent implements OnInit {
  @Input() selected: number

  constructor(private productsService: ProductsService) { }

  ngOnInit(): void { }

  get products() { return this.productsService.products }

  calculateBarTop(i: number): number {
    const total = this.products.length;
    const offset = 10;
    return  offset + (100 - offset * 2) / total * i;
  }
}
